import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.split";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import MapService from '../../../services/mapService';
import SocketMixin from '../../../components/core/dtwin/socketMixin';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import cloneDeep from 'lodash/cloneDeep';
var localStorageKey = 'is-warnapp-dtwin-id';
export default {
  name: 'ViewISWarnappViewer',
  mixins: [SocketMixin],
  data: function data() {
    return {
      // if a twin has been selected before and is loaded from the local-storage on page-load,
      // there is no user-interaction which is required for the audio-player
      // thus, show a big button on the screen to "start" the monitor
      showInitialInteractionButton: true,
      dummyAudioInterval: null,
      treeMenu: false,
      treeMenuPosition: {},
      soundIsMuted: false,
      selectedDtwin: {},
      dtwinAncestors: {},
      warnState: {},
      alarmHigh: null,
      alarmLow: null,
      statusConfigs: {
        good: {
          key: 'good',
          label: this.$i18n_t('IS.Warnapp.good'),
          // img: 'img/modules/is-warnapp/thumbsup.png',
          icon: 'fal fa-check-square',
          bgColor: 'rgba(0, 180, 0)'
        },
        okay: {
          key: 'okay',
          label: this.$i18n_t('IS.Warnapp.okay'),
          // img: 'img/modules/is-warnapp/okay.jpg',
          icon: 'fal fa-hand-lizard',
          bgColor: 'rgba(230, 200, 10)'
        },
        bad: {
          key: 'bad',
          label: this.$i18n_t('IS.Warnapp.bad'),
          // img: 'img/modules/is-warnapp/motherofgod.png',
          icon: 'fal fa-thumbs-down',
          bgColor: 'rgba(180, 0, 0)'
        },
        unknown: {
          key: 'unknown',
          label: this.$i18n_t('IS.Warnapp.unknown'),
          img: 'img/modules/is-warnapp/shoulder.jpg',
          bgColor: 'rgba(80, 80, 80)'
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    mode: function mode() {
      return this.UiTheme ? 'dark' : 'light';
    },
    opacity: function opacity() {
      return this.UiTheme ? '0.6' : '0.85';
    },
    homeLink: function homeLink() {
      return this.$store.state.app.sidebarIconLink || '/home';
    },
    formattedStateValue: function formattedStateValue() {
      var currentValue = parseFloat(get(this.warnState, 'value.value'));
      var visualOptions = get(this.warnState, 'properties.visual.options');

      if (!isNaN(currentValue) && visualOptions && get(this.warnState, 'properties.visual.type') === 'gauge' && get(this.warnState, 'properties.valueType') === 'number') {
        return "(".concat(Math.round(currentValue), " ").concat(this.warnState.properties.unit, ")");
      }

      return null;
    },
    audioPath: function audioPath() {
      var _this = this;

      var raiseTheRoof = this.statusDetails.key === 'bad';
      this.$nextTick(function () {
        var player = _this.$refs['alarm-player'];

        if (player && !_this.showInitialInteractionButton) {
          navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;

          if (raiseTheRoof) {
            player.play(); // optionally, vibrate if the device supports it

            if (navigator.vibrate) {
              // 3 vibration bursts with 1s pause between
              navigator.vibrate([500, 1000, 500, 1000, 500]);
            }
          } else {
            player.pause(); // eslint-disable-next-line vue/no-side-effects-in-computed-properties

            player.currentTime = 0.0;

            if (navigator.vibrate) {
              navigator.vibrate(0);
            }
          }
        }
      });
      return this.alarmAudioUrl;
    },
    statusDetails: function statusDetails() {
      var currentValue = parseFloat(get(this.warnState, 'value.value'));
      var visualOptions = get(this.warnState, 'properties.visual.options');

      if (!isNaN(currentValue) && visualOptions && get(this.warnState, 'properties.visual.type') === 'gauge' && get(this.warnState, 'properties.valueType') === 'number') {
        var _currentValue = parseFloat(this.warnState.value.value);

        var quality = 'unknown';
        var highValue = parseFloat(visualOptions.min) + (parseFloat(visualOptions.max) - parseFloat(visualOptions.min)) * 0.66;
        var lowValue = parseFloat(visualOptions.min) + (parseFloat(visualOptions.max) - parseFloat(visualOptions.min)) * 0.33;

        if (this.alarmHigh) {
          highValue = parseFloat(this.alarmHigh.value.value);
        }

        if (this.alarmLow) {
          lowValue = parseFloat(this.alarmLow.value.value);
        }

        quality = _currentValue <= lowValue ? 'good' : _currentValue > highValue ? 'bad' : 'okay';
        var bgColor = this.statusConfigs[quality].bgColor; // find the threshold-index for the actual color from the gauge-config

        var thresholds = get(visualOptions, 'thresholds', '').split(',').map(function (v) {
          return parseFloat(v);
        });
        var sortedThresholds = cloneDeep(thresholds).sort(function (a, b) {
          return a - b;
        }); // find the first threshold in the sorted list that is smaller than the current value

        var nextSmallerThreshold = parseFloat(visualOptions.max);

        for (var i = 0; i < sortedThresholds.length; i++) {
          if (sortedThresholds[i] >= _currentValue) {
            break;
          }

          nextSmallerThreshold = sortedThresholds[i];
        }

        var tIndex = thresholds.indexOf(nextSmallerThreshold); // if not found, will use the first color, which maps to "min"

        bgColor = visualOptions.thresColors[tIndex + 1];
        return _objectSpread(_objectSpread({}, this.statusConfigs[quality]), {}, {
          bgColor: bgColor
        });
      }

      return this.statusConfigs['unknown'];
    },
    logoUrl: function logoUrl() {
      return this.findAncestorAttachment(get(this.selectedDtwin, 'id'), /^warnapp_logo\.(jp(e?)g|png|gif)$/i);
    },
    alarmAudioUrl: function alarmAudioUrl() {
      return this.findAncestorAttachment(get(this.selectedDtwin, 'id'), /^warnapp_alarm\.(o(pus|g([gax]{1}))|spx|webm|mp3|(fl|a)ac|wav(e?))$/i) || 'img/modules/is-warnapp/alarm.mp3';
    }
  }),
  watch: {
    soundIsMuted: function soundIsMuted() {
      var _this2 = this;

      this.$nextTick(function () {
        var player = _this2.$refs['alarm-player'];

        if (player) {
          player.volume = _this2.soundIsMuted ? 0 : 1;
        }
      });
    },
    showInitialInteractionButton: function showInitialInteractionButton() {
      this.warnState = cloneDeep(this.warnState);
    }
  },
  destroyed: function destroyed() {
    if (this.dummyAudioInterval) {
      clearTimeout(this.dummyAudioInterval);
    }
  },
  created: function created() {
    var _this3 = this;

    var dtwinId = localStorage.getItem(localStorageKey);

    if (dtwinId) {
      ApiService.digitalTwinGet(this, dtwinId).then(function (data) {
        _this3.digitalTwinSelected(data);
      }).catch(function (error) {
        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this3.$snack(_this3.$i18n_t('Common.digitalTwins.twinNotFound'), 'error');
        }
      });
    }
  },
  methods: {
    get: get,
    playDummyAudio: function playDummyAudio(scope) {
      // setTimeout-handling requires the "scope" to be handed over as parameter
      // for the first time calling there is no scope yet, it is the original vue-component
      var instance = scope || this;
      instance.$nextTick(function () {
        var dummyPlayer = instance.$refs['dummy-audio'];
        dummyPlayer.play();
      });
      instance.dummyAudioInterval = setTimeout(instance.playDummyAudio, 30 * 1000, instance);
    },
    mixedColorForValue: function mixedColorForValue(visualOptions, stateValue) {
      var values = [parseFloat(visualOptions.min)].concat(visualOptions.thresholds.split(',').map(function (t) {
        return parseFloat(t);
      }));
      var index = 0;

      for (var i = 0; i < values.length; i++) {
        if (values[i] < stateValue) {
          break;
        }
      }

      var bgColor = MapService.convertToRgba(visualOptions.thresColors[index], 0.35);

      if (index !== values.length - 1) {
        var colors = [visualOptions.thresColors[index], visualOptions.thresColors[index + 1]];
        var mix = (stateValue - values[index]) / (values[index + 1] - values[index]);
        bgColor = MapService.mixRgbaColor(colors[0], colors[1], mix);
      }

      return bgColor;
    },
    findTwinInTree: function findTwinInTree(dtwinId) {
      var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (!dtwinId) {
        return null;
      }

      var searching = list || get(this.dtwinAncestors, 'digitaltwins') || [];

      for (var i = 0; i < searching.length; i++) {
        if (searching[i].id === dtwinId) {
          return searching[i];
        } else {
          var foundTwin = this.findTwinInTree(dtwinId, get(searching[i], 'children', []));

          if (foundTwin) {
            return foundTwin;
          }
        }
      }

      return null;
    },
    findAncestorAttachment: function findAncestorAttachment(dtwinId, regex) {
      if (!dtwinId) {
        return null;
      }

      var twinObject = {};

      if (dtwinId === this.selectedDtwin.id) {
        twinObject = this.selectedDtwin;
      } else {
        twinObject = this.findTwinInTree(dtwinId);
      }

      var attachments = get(twinObject, 'data.attachments', []);
      var matchAttachment = attachments.find(function (a) {
        return regex.test(a.name);
      });

      if (matchAttachment) {
        return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(matchAttachment.id);
      }

      return this.findAncestorAttachment(get(twinObject, 'parentId'), regex);
    },
    doOpenTree: function doOpenTree(e) {
      e.preventDefault();
      this.showInitialInteractionButton = false;
      this.treeMenuPosition = {
        x: e.clientX,
        y: e.clientY
      };
      this.treeMenu = true;
    },
    digitalTwinFilter: function digitalTwinFilter(item) {
      if (isArray(get(item, 'data.tags', []))) {
        return get(item, 'data.tags', []).findIndex(function (t) {
          return t.toLowerCase() === 'warnapp-sensor';
        }) >= 0;
      }

      return false;
    },
    digitalTwinSelected: function digitalTwinSelected(e) {
      // NOTE: the tree emits the selection of a twin right after startup
      // this would lead to the tree never really opening, if the already selected twin is emitted again
      // so in that case, ignore the emission as nothing changes
      if (e && this.selectedDtwin && e.id === this.selectedDtwin.id) {
        return;
      }

      localStorage.setItem(localStorageKey, get(e, 'id'));
      this.selectedDtwin = e || {};
      this.treeMenu = false;

      if (this.selectedDtwin.id) {
        this.loadStates();
      } else {
        this.warnState = undefined;
      }
    },
    loadStates: function loadStates() {
      var _this4 = this;

      Promise.all([ApiService.digitalTwinFetchPartialTree(this, this.selectedDtwin.parentId, undefined, undefined, ['no-children']), ApiService.digitalTwinFetchStates(this, this.selectedDtwin.id)]).then(function (states) {
        _this4.dtwinAncestors = states[0];
        _this4.warnState = states[1].find(function (s) {
          return s.key.toLowerCase() === 'warnapp_gauge';
        });
        _this4.alarmHigh = states[1].find(function (s) {
          return s.key.toLowerCase() === 'warnapp_alarm_high';
        });
        _this4.alarmLow = states[1].find(function (s) {
          return s.key.toLowerCase() === 'warnapp_alarm_low';
        });

        if (_this4.warnState) {
          _this4.setupDtwinSocket(_this4.selectedDtwin.id);
        }
      }).catch(function (error) {
        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('Common.digitalTwins.errorFindingDTwins'), 'error');
        }
      });
    },
    statesValuesUpdated: function statesValuesUpdated(statesData) {
      var _this5 = this;

      var matchWarnState = statesData.find(function (s) {
        return s.id === _this5.warnState.id;
      });

      if (matchWarnState) {
        this.warnState.value.value = matchWarnState.value;
        this.warnState = cloneDeep(this.warnState);
      }

      var matchAlarmHighState = statesData.find(function (s) {
        return s.id === get(_this5.alarmHigh, 'id');
      });

      if (matchAlarmHighState) {
        this.alarmHigh.value.value = matchAlarmHighState.value;
        this.alarmHigh = cloneDeep(this.alarmHigh);
      }

      var matchAlarmLowState = statesData.find(function (s) {
        return s.id === get(_this5.alarmLow, 'id');
      });

      if (matchAlarmLowState) {
        this.alarmLow.value.value = matchAlarmLowState.value;
        this.alarmLow = cloneDeep(this.alarmLow);
      }
    }
  }
};